import Loading from '../../../../shared/Loading/Loading';
import Sort from './Sort';
import Card from './Card';

const List = ({
  loading,
  filteredInteractions,
  displayedInteractions,
  query,
  sortConfig,
  sortOptions,
  setSortColumn,
  toggleSortDirection,
  mode,
  editable,
  editedScores,
  loadingUpdate,
  handleScoreChange,
}) => {
  const wrapperClassName = mode === 'resume'
    ? 'px-4 pb-4'
    : mode === 'modal'
      ? 'px-4 py-4 space-y-3'
      : 'px-4 py-4 space-y-3 md:hidden';

  return (
    <div className={wrapperClassName}>
      {mode === 'principal' &&
        <Sort
          sortConfig={sortConfig}
          sortOptions={sortOptions}
          setSortColumn={setSortColumn}
          toggleSortDirection={toggleSortDirection}
        />
      }
      {loading ? (
        <div className="flex justify-center py-10">
          <Loading size="28" colorBase="white" colorAccent="personalized" double={true} bold="8" />
        </div>
      ) : filteredInteractions.length === 0 ? (
        <p className="px-4 py-6 text-center text-sm text-gray-500">
          {query
            ? `No hay coincidencias para “${query}”`
            : mode === 'resume' ? 'No hay actividades realizadas actualmente' : 'No hay interacciones disponibles'}
        </p>
      ) : (
        <ul className={mode === 'resume' ? 'divide-y divide-gray-200' : mode === 'modal' ? 'space-y-3' : 'divide-y divide-gray-200'}>
          {(displayedInteractions ?? filteredInteractions).map((interaction, index) => (
            <Card
              key={index}
              interaction={interaction}
              mode={mode}
              editable={editable}
              editedScores={editedScores}
              loadingUpdate={loadingUpdate}
              handleScoreChange={handleScoreChange}
            />
          ))}
        </ul>
      )}
    </div>
  );
};

export default List;
